// Shopify inserts its privacy banner after the theme has loaded.
// Keep its accessible label without adding a heading to the page outline.
(() => {
  const selector = 'h2#shopify-pc__banner__body-title';
  const properties = [
    'font-family', 'font-size', 'font-weight', 'font-style', 'line-height',
    'letter-spacing', 'text-transform', 'color', 'margin-top', 'margin-right',
    'margin-bottom', 'margin-left',
  ];

  function replaceHeading(heading) {
    const label = document.createElement('div');
    for (const attribute of heading.attributes) {
      label.setAttribute(attribute.name, attribute.value);
    }
    // The banner stylesheet can target h2 directly; retain its current appearance.
    const styles = getComputedStyle(heading);
    for (const property of properties) {
      label.style.setProperty(property, styles.getPropertyValue(property));
    }
    label.append(...heading.childNodes);
    heading.replaceWith(label);
  }

  function update(root) {
    if (!(root instanceof Element)) return;
    if (root.matches(selector)) replaceHeading(root);
    else root.querySelectorAll(selector).forEach(replaceHeading);
  }

  update(document.body);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) update(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
